module.exports = __webpack_public_path__ + "static/media/r246.70d98815.jpg";